import SideNav from "./SideNav";
import TopBar from "./TopBar";
import React, { useState,  useEffect, useRef } from 'react';
import axios from 'axios';
import { BrowserRouter as Router,Switch,Route,Link,useNavigate,useParams,params} from "react-router-dom";
import Swal from 'sweetalert2';
import placeholderImage from '../img/image_placeholder.png'
import Select from 'react-select';
import $ from 'jquery';
// import 'datatables.net';
// import 'datatables.net-dt/css/jquery.dataTables.css';
import ReactPaginate from 'react-paginate';
import noImagePlaceholder from '../img/no_image_placeholder.png';


function ViewInventory(){
  
  const navigate = useNavigate();
    const [inventory, setInventory] = useState([]);
    const [coverImages, setCoverImages] = useState([]);
    const [mergedArray, setMergedArray] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [usernameDisplay, setUsernameDisplay] = useState('');
    const [isImageLoading, setIsImageLoading] = useState(true);
    const [disableMakeOptions, setDisableMakeOptions] = useState(true);
    const [disableModelOptions, setDisableModelOptions] = useState(true);
    const [isSearch, setIsSearch] = useState(false);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [sortedOption, setSortedOption] = useState('postedNewToOld');
    const [sortedOptionSearch, setSortedOptionSearch] = useState('postedNewToOld');
    const [sortedOptionFiltered, setSortedOptionFiltered] = useState('');
    const [searchText, setSearchText]= useState('');
   

  
    const API_URL = process.env.REACT_APP_API_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

    const [selectedInventoryType, setSelectedInventoryType] = useState({ label: "Local Inventory", value: "false" });
    const [selectedMake, setSelectedMake] = useState([]);
    const [selectedModel, setSelectedModel] = useState("");
    const [minPrice, setMinPrice] = useState("");
const [maxPrice, setMaxPrice] = useState("");
const [minKilometer, setMinKilometer] = useState("");
const [maxKilometer, setMaxKilometer] = useState("");

    const [inventoryTypeOptions, setInventoryTypeOptions] = useState([
      
        { value: 'false', label: 'Local Inventory' },
        { value: 'true', label: 'Global Inventory' },
        { value: 'all', label: 'All' }
      
    ]);
    const [makeOptions, setMakeOptions] = useState([]);
    const [modelOptions, setModelOptions] = useState([]);
    const [selectedMakes, setSelectedMakes] = useState([]);
    const [selectedModels, setSelectedModels] = useState([]);


    const [recordCount, setRecordCount] = useState();
    const [searchRecordCount, setSearchRecordCount] = useState();
    const [totalCount, setTotalCount] = useState(0); 
    const [selectedCount, setSelectedCount] = useState(0);
    const [filteredResults, setFilteredResults] = useState([]); 
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showCheckbox, setShowCheckbox] = useState(false);
    const selectAllCheckboxRef = useRef(null);
  

    const handleButtonClick = () => { 
      setShowCheckbox(!showCheckbox);

    };

    const handleSelectAll = (e) => {
      const checked = e.target.checked;
      const allItemIds = getCurrentData().map((item) => item.id);
      if (checked) {
        setSelectedRows(allItemIds);
      } else {
        setSelectedRows([]);
      }
    };

    const handleRowSelect = (e, id) => {
      const checked = e.target.checked;
      let updatedSelectedRows;
    
      if (checked) {
        updatedSelectedRows = [...selectedRows, id];
      } else {
        updatedSelectedRows = selectedRows.filter((row) => row !== id);
      }
    
      setSelectedRows(updatedSelectedRows);
  
      const allRowsSelected = getCurrentData().every((item) => updatedSelectedRows.includes(item.id));   
      selectAllCheckboxRef.current.checked = allRowsSelected; 
    };
  
   

    const handleEmailInventory = () => {
      setLoading(true)
      const queryParams = selectedRows.join(",");
      const makesQueryParam = selectedMakes && selectedMakes.length > 0 ? `selectedMakes=${selectedMakes.join(",")}` : "";
      const modelsQueryParam = selectedModels && selectedModels.length > 0 ? `selectedModels=${selectedModels.join(",")}` : "";
      const queryString = [queryParams, makesQueryParam, modelsQueryParam].filter(queryParam => queryParam !== "").join("&");
   


      // const queryString = selectedRows.map((id) => {
      //   const selectedItem = getCurrentData().find((item) => item.id === id);
      //   return `selectedMakes=${selectedItem.brand}&selectedModels=${selectedItem.model_name}`;
      // }).join("&");

      // const queryParams = selectedRows.join(",");
      // const selectedParams = selectedRows.map((id) => {
      //   const selectedItem = getCurrentData().find((item) => item.id === id);
      //   return selectedItem ? `selectedMakes=${selectedItem.brand}&selectedModels=${selectedItem.model_name}` : '';
      // });
      
      // const queryString = [queryParams, ...selectedParams].filter(queryParam => queryParam !== '').join('&');

      // console.log(queryString);
     // window.location.href = `/vehicle-list?selectedRows=${queryString}`;
     navigate(`/vehicle-list?selectedRows=${queryString}`);
  };
  

    const filteredResult = filteredInventory.filter((item) => {
      return item.vehicle_name && item.vehicle_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.trim && item.trim.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.drive_type &&  item.drive_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.price && item.price.sale_price.toString().includes(searchQuery);
       
    });

    useEffect(() => {   
 
       setIsLoading(true);
        getInventoryList();   
        search();
       
        }, []);

       

async function getInventoryList(){
 
        axios.get(`${API_URL}/view-inventory`).then(res=>{
            if(res.data.status === 200){
              const inventory = res.data.inventorySection;
                setInventory(res.data.inventorySection);             
                setCoverImages(res.data.inventoryCoverImages);

                  const mergedArray =    res.data.inventorySection.map(section => {
                  const coverImage = res.data.inventoryCoverImages.find(image => image.inventory_section_id === section.id);
                  const price = res.data.inventorySection3.find(data => data.inventory_section_id === section.id);
                  const inventoryImages = res.data.inventoryImages.find(image => image.inventory_section_id === section.id);
                  let count = 0;

if (inventoryImages && inventoryImages.filepath_compressed) {
  count += inventoryImages.filepath_compressed.split(',').length;
}

if (coverImage && coverImage.filepath) {
  count += coverImage.filepath.split(',').length;
}

                  //const count = (inventoryImages.filepath_compressed.split(',').length) + (coverImage.filepath.split(',').length)
                  return { ...section, coverImage, price, count };    
               
                })
              
                setMergedArray(res.data.inventorySection.map(section => {
                    const coverImage = res.data.inventoryCoverImages.find(image => image.inventory_section_id === section.id);
                    const price = res.data.inventorySection3.find(data => data.inventory_section_id === section.id);
                    const inventoryImages = res.data.inventoryImages.find(image => image.inventory_section_id === section.id);
                  //  const count = (inventoryImages.filepath_compressed.split(',').length) + (coverImage.filepath.split(',').length)
                  let count = 0;

                  if (inventoryImages && inventoryImages.filepath_compressed) {
                    count += inventoryImages.filepath_compressed.split(',').length;
                  }
                  
                  if (coverImage && coverImage.filepath) {
                    count += coverImage.filepath.split(',').length;
                  }
                  
                    return { ...section, coverImage, price, inventoryImages, count };    
                 
                  }))   

                const selectedInventory = inventory.filter((row) => row.global_inventory === "false");
                const uniqueMake = [...new Set(selectedInventory.map(row => row.brand.toLowerCase()))]
                .map(make => make.charAt(0).toUpperCase() + make.slice(1));
                setMakeOptions(uniqueMake ? uniqueMake : []);

                  const filteredInventory = mergedArray.filter((item) => item.global_inventory === "false");
                  setFilteredInventory(filteredInventory);
         
                     // Sorting by 'postedNewToOld' when no option selected onload
                     setFilteredInventory(filteredInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));  
                   
              
 
            }
            else if(res.data.status === 404){
                setMessage(res.data.message);
                //console.log(res.data.status);
                }
                
            setIsLoading(false);
         });
           
        }
       
        

       const deleteInventory = (e,id) =>{
        e.preventDefault();
        var buttonClicked = window.confirm("Are you sure you want to delete inventory?");
        if(buttonClicked == true){
           // const thisClicked = e.currentTarget;
          //  thisClicked.innerText = "Deleting";
            axios.delete(`${API_URL}/delete-inventory/`+id).then(res => {  
                axios.delete(`${API_URL}/delete-inventory2/`+id).then(res => { })
                axios.delete(`${API_URL}/delete-invoice-cart/`+id).then(res => {})
                axios.delete(`${API_URL}/delete-cover-image/`+id).then(res => {})
                axios.delete(`${API_URL}/delete-inventory-images/`+id).then(res => {})
          Swal.fire({
                  icon:"success",
                  text:res.data.message
                }).then(function(){  
                  
                       
                         // thisClicked.closest("tr").remove();                           
              });
              getInventoryList();
            })
        }
        else{
            getInventoryList();
        }
 
       }
       
       const handleImageLoad = () => {
          setIsImageLoading(false);
         // setIsLoading(false);
      };
      

      const handleInventoryTypeChange  = (selectedOptions) => {
   
        setSelectedInventoryType(selectedOptions);

        if (selectedOptions.value === 'all') {
           // console.log(inventory.map(row => row.year));
       
            const uniqueMake = [...new Set(inventory.map(row => row.brand.toLowerCase()))]
            .map(make => make.charAt(0).toUpperCase() + make.slice(1));
          //  const uniqueModel = [...new Set(inventory.map(row => row.model_name))];         
            setDisableMakeOptions(false); 
            setModelOptions([]);
            setMakeOptions(uniqueMake ? uniqueMake : []);
            setSelectedMakes([]);
            setSelectedModels([]);

           //setModelOptions(uniqueBrand ? uniqueBrand : []);
          } else {
            const selectedInventory = inventory.filter((row) => row.global_inventory === selectedOptions.value);

            const uniqueMake = [...new Set(selectedInventory.map(row => row.brand.toLowerCase()))]
      .map(make => make.charAt(0).toUpperCase() + make.slice(1));
           // const uniqueBrand = [...new Set(selectedInventory.map(row => row.brand))];
            //console.log(selectedInventory.map(row => row.year));
         
           setDisableMakeOptions(false);
           setModelOptions([]);
             setMakeOptions(uniqueMake ? uniqueMake : []);
             setSelectedMakes([]);
             setSelectedModels([]);
            // setModelOptions(uniqueBrand ? uniqueBrand : []);
         
          }
        
};


const handleMakeChange = (selectedOptions) => {
  const selectedMakeValues = selectedOptions.map(option => option.value);
  setSelectedMakes(selectedMakeValues);
  // Update model options based on selected makes
  const filteredModels = inventory.filter(row => selectedMakeValues.includes(row.brand))
    .map(row => row.model_name.toLowerCase());
  const uniqueModels = [...new Set(filteredModels)];
  const formattedUniqueModels = uniqueModels.map(model => model.charAt(0).toUpperCase() + model.slice(1));
  setModelOptions(formattedUniqueModels);
};

const handleModelChange = (selectedOptions) => {
  const selectedModelValues = selectedOptions.map(option => option.value);
  setSelectedModels(selectedModelValues);
};


async function search() {
  setFilteredResults([]);
  setSearchQuery('');
  setIsSearch(true);
  //setLoading(true);
 
 
    if (selectedInventoryType === "") {
      document.getElementById("errorMessage").style.display = "block";
    }
    else{
      document.getElementById("errorMessage").style.display = "none";
    }
 

const filteredInventory = mergedArray.filter((item) => {
      return (
        (selectedInventoryType.value === 'all' || item.global_inventory === selectedInventoryType.value) &&
        (!selectedMakes.length || selectedMakes.includes(item.brand) || 
        (selectedMakes.includes(item.brand) && selectedModels.includes(item.model_name)) )&&
        (!minPrice ||  item.price && item.price.sale_price >= minPrice) &&
        (!maxPrice || item.price && item.price.sale_price <= maxPrice) &&
        (!minKilometer || item.odometer >= minKilometer) &&
        (!maxKilometer || item.odometer <= maxKilometer)
      );
    })
    
  //setFilteredInventory(filteredInventory);
  setFilteredInventory(filteredInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));  

setIsImageLoading(true);
}
// useEffect(() => {
//    const count = filteredResult.length;
//   setRecordCount(count);


// }, [filteredInventory]);  



// const handleSearch = (text) => {
//   setFilteredResults([""]);
//   setSearchText("");
//   const searchText = text.toLowerCase();
//   const keywords = searchText.split(" ");
//   const filteredResults = filteredInventory.filter(item => {
//     const itemBrand = item.brand.toLowerCase();
//     const itemModel = item.model_name.toLowerCase();
//     const itemYear = item.year.toString();
//     const itemKm = item.odometer.toString();
//     const itemPrice = item.price.sale_price.toString();
//     return keywords.every(keyword => itemBrand.includes(keyword) || itemModel.includes(keyword) || itemYear.includes(keyword) ||
//     itemKm.includes(keyword) || itemPrice.includes(keyword));
//   });
//   setFilteredResults(filteredResults);
//   //setFilteredInventory(filteredResults);
//   console.log(filteredResults);

//   const pageText = document.body.innerText.toLowerCase();
//   const totalCount = (pageText.match(new RegExp(searchText, "gi")) || []).length; // total count


//   if (pageText.includes(searchText)) {
//     const selectedCount = window.find(searchText) ?  1 : 0; // selected count

//     setTotalCount(totalCount);
//     setSelectedCount(selectedCount);
  
//     if (selectedCount > 0) {
//       const selectedElement = window.getSelection().focusNode.parentElement;
//       selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     }
  
//   } else {
//     setTotalCount(0);
//     setSelectedCount(0);
//   //  alert('Text not found!');
//   }
//   // console.log(selectedCount,totalCount);
// };

const handleSortedOptionChange = (event) => {
  const option = event.target.value;
  setSortedOption(option);
  handleSort(option);


};


const handleSort = (option) => {
  let sortedInventory = [...filteredInventory];

  switch (option) {
    case 'postedNewToOld':
      sortedInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      break;
    case 'postedOldToNew':
      sortedInventory.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      break;    
      case 'priceLowToHigh':
        sortedInventory.sort((a, b) => {
          if (a.price && a.price.sale_price && b.price && b.price.sale_price) {
            return a.price.sale_price - b.price.sale_price;
          } else if (!a.price || !a.price.sale_price) {
            return 1; // Sort a after b if a has undefined price
          } else if (!b.price || !b.price.sale_price) {
            return -1; // Sort b after a if b has undefined price
          } else {
            return 0; // Both prices are undefined, consider them equal
          }
        });
        break;
      case 'priceHighToLow':
        sortedInventory.sort((a, b) => {
          if (a.price && a.price.sale_price && b.price && b.price.sale_price) {
            return b.price.sale_price - a.price.sale_price;
          } else if (!a.price || !a.price.sale_price) {
            return 1; // Sort b after a if a has undefined price
          } else if (!b.price || !b.price.sale_price) {
            return -1; // Sort a after b if b has undefined price
          } else {
            return 0; // Both prices are undefined, consider them equal
          }
        });
        break;
    case 'kmLowToHigh':
      sortedInventory.sort((a, b) => a.odometer - b.odometer);
      break;
    case 'kmHighToLow':
      sortedInventory.sort((a, b) => b.odometer - a.odometer);
      break;
    case 'yearHighToLow':
      sortedInventory.sort((a, b) => b.year - a.year);
      break;
    case 'yearLowToHigh':
      sortedInventory.sort((a, b) => a.year - b.year);
      break;
    default:
    // Sorting by 'postedNewToOld' when no option selected onload
    sortedInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    break;
  }

  setFilteredInventory(sortedInventory);

  // if (sortedInventory.length !== sortPrevLength) {
     setIsImageLoading(true); 
      // setSortPrevLength(sortedInventory.length);}

};



const handleSearch = () => {
  

  const filteredResults = filteredInventory.filter(
    (item) =>
     // item.global_inventory === "false" &&
      item.vehicle_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.trim.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.drive_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.price.sale_price.toString().includes(searchQuery) 
  );
 setFilteredResults(filteredResults);
 setSearchRecordCount(filteredResults.length);

if(searchQuery.length==0){
  setFilteredResults('');
}

  
};

const handleSortedOptionChangesearch = (event) => {
  const option = event.target.value;
  setSortedOptionSearch(option);
  handleSortSearch(option);
};


const handleSortSearch = (option) => {
  let sortedInventory = [...filteredResults];

  switch (option) {
    case 'postedNewToOld':
      sortedInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      break;
    case 'postedOldToNew':
      sortedInventory.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      break;    
      case 'priceLowToHigh':
      sortedInventory.sort((a, b) => {
        if (a.price && a.price.sale_price && b.price && b.price.sale_price) {
          return a.price.sale_price - b.price.sale_price;
        } else {
          return Number.POSITIVE_INFINITY; // No sale price, consider them equal
        }
      });
      break;
    case 'priceHighToLow':
      sortedInventory.sort((a, b) => {
        if (a.price && a.price.sale_price && b.price && b.price.sale_price) {
          return b.price.sale_price - a.price.sale_price;
        } else {
          return Number.NEGATIVE_INFINITY; // No sale price, consider them equal
        }
      });
      break;
    case 'kmLowToHigh':
      sortedInventory.sort((a, b) => a.odometer - b.odometer);
      break;
    case 'kmHighToLow':
      sortedInventory.sort((a, b) => b.odometer - a.odometer);
      break;
    case 'yearHighToLow':
      sortedInventory.sort((a, b) => b.year - a.year);
      break;
    case 'yearLowToHigh':
      sortedInventory.sort((a, b) => a.year - b.year);
      break;
    default:
    sortedInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    break;
  }

  setFilteredResults(sortedInventory);
};



const handlePageChange = (selectedPage) => {
  setCurrentPage(selectedPage.selected);
 
};


const getCurrentData = () => {
  const offset = currentPage * perPage;
  const currentData = filteredResult.slice(offset, offset + perPage);
  return currentData;
};

  function clearFilters()  {
setLoading("true");
  setIsImageLoading(true);
  setSelectedMakes([]);
  setSelectedModels([]);
  setMinKilometer('');
  setMaxKilometer('');
  setMinPrice('');
  setMaxPrice('');
  setSelectedInventoryType({ label: "Local Inventory", value: "false" });


  const selectedInventory = inventory.filter((row) => row.global_inventory === "false");
  const uniqueMake = [...new Set(selectedInventory.map(row => row.brand.toLowerCase()))]
  .map(make => make.charAt(0).toUpperCase() + make.slice(1));
  setMakeOptions(uniqueMake ? uniqueMake : []);
    const filteredInventory = mergedArray.filter((item) => item.global_inventory === "false");
    setFilteredInventory(filteredInventory);
       // Sorting by 'postedNewToOld' when no option selected onload
       setFilteredInventory(filteredInventory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));  
       setModelOptions([]);
       setLoading(false);
};



    return(
        <div>
      <SideNav/>
      <TopBar/>
   {/* <TopBar handleSearch={handleSearch} filteredResult={filteredResults}
   totalCount={totalCount} selectedCount={selectedCount} /> */}
    {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}


    <div class="right_panel inventory vh-100" id="right_panel">
        
    <div class="main_title"   data-aos-delay="" data-aos-duration="1200">
            <h1><i class="bi bi-car-front-fill"></i> Inventory</h1>
          <div class="d-flex justify-content-end" >
         
            {selectedRows.length > 0 && showCheckbox && (
            <button class="btn btn-sm btn_secondary" style={{marginRight:"10px",background: "#3d3d3d"}} onClick={handleEmailInventory}>{loading?'Generating...':'Generate'}</button>)}
            
            <button class="btn btn-sm btn_secondary" style={{marginRight:"10px"}} onClick={handleButtonClick}>Email Inventory</button>
        
                <button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" >
                    <Link style={{color:"white"}} to={'/Inventory'}>Create New Inventory</Link></button>
                    </div>
         </div>



         <div class="content_wrapper pt-0">
    <div class="vm_content_box_1">
    
        <div class="content pt-3">  
                      
                        <div class="content pt-3 pb-1">
                            <div class="row">
                           
                            <div class="col-md-2 form-group">                 
<Select 
        placeholder="Select Inventory Type"
        onChange={handleInventoryTypeChange}
        menuPortalTarget={document.body}
        value={selectedInventoryType}
        defaultValue={{ label: "Local Inventory", value: "false" }}
        options={inventoryTypeOptions}
       
        />
              
        <p id="errorMessage" style={{color: "red", display: "none",marginTop: "12px"}}>Please select inventory type</p> </div>
                               
                                <div class="col-md-2 form-group">
<Select 
        value={selectedMakes.map(make => ({ value: make, label: make}))}
        options={makeOptions.map(make => ({ value: make, label: make }))}
        isMulti
        placeholder="Select Make"
        onChange={handleMakeChange}
        menuPortalTarget={document.body}
        noOptionsMessage={() => 'No options available'}
      
      />

                                </div>

                                <div class="col-md-2 form-group">
 <Select
        value={selectedModels.map(model => ({ value: model, label: model}))}
        options={modelOptions.map(model => ({ value: model, label: model }))}
        isMulti
        placeholder="Select Model"
        onChange={handleModelChange}
        menuPortalTarget={document.body}
        noOptionsMessage={() => 'No options available'}
      />

                                </div>
                              
                                <div class="col-md-3 form-group d-flex ">
  <div class="d-flex input_wrapper">
    <div class="icon_wrapper" style={{height:'37px'}}><i class="bi bi-currency-dollar text-white"></i></div>
    <input type="number" class="form-control" style={{height: "37px", boxShadow: "none", borderRadius: "4px"}} name="minPrice" id="minPrice" placeholder="Min Price" value={minPrice} onChange={(e) => setMinPrice(e.target.value)} min="0"/>
    {/* <div class="icon_wrapper"><i class="bi bi-currency-dollar text-white"></i></div> */}
    <input type="number" class="form-control" style={{height: "37px", boxShadow: "none", borderRadius: "4px"}} name="max_price" id="max_price" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} min="0"/>
  </div>
</div>
<div class="col-md-3 form-group">
    <div class="d-flex input_wrapper">
        <input type="number" class="form-control" style={{height: "37px", boxShadow: "none", borderRadius: "4px"}} name="minKilometer" id="minKilometer" placeholder="Min Kilometer"
            value={minKilometer} onChange={(e) => setMinKilometer(e.target.value)} min="0"/>
        <input type="number" class="form-control" style={{height: "37px", boxShadow: "none", borderRadius: "4px"}} name="maxKilometer" id="maxKilometer" placeholder="Max Kilometer"
            value={maxKilometer} onChange={(e) => setMaxKilometer(e.target.value)} min="0"/>
    </div>
</div>
                               
                             
                                <div class="col-md-1" > <button onClick={search} class="border px-2 py-2 d-inline vm_bg_secondary text-white vm_cursor_pointer" >
                        <i class="bi bi-search me-1"></i> {loading ? "Searching..." : "Search"}
                    </button></div>  

                    <div class="col-md-2" > <button class="border px-2 py-2 vm_cursor_pointer" onClick={clearFilters} style={{color:"#1477d4", backgroundColor:"white"}}>
                         {loading ?'clearing...':'Clear filters'}
                    </button></div> 

                            </div>
                           
                     
                            
                            </div>
                            </div> 
        </div>
    </div>



             <div class="content_wrapper pt-0"  data-aos-delay="" data-aos-duration="1200">
             <div>
            
                <div class="vm_content_box_1" >

                    <div class="content">
                   
 
                  <>
                  <div class="row">
                  <div class="row pt-3">
                          
                          <div class="col-md-6 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                              
                   
                                  </div>
                              </div>

                              <div class="col-md-3 form-group">
  <div class="d-flex input_wrapper" style={{alignItems: "baseline"}}>
    <label class="mr-2">Sort by</label>
    <div style={{ marginLeft: "10px"}}>
      <select class="form-select" name="condition" id="condition" value={sortedOption} onChange={handleSortedOptionChange}>
        <option value="">Select an option</option>
        <option value="postedNewToOld">Posted Date: New to Old</option>
        <option value="postedOldToNew">Posted Date: Old to New</option>              
        <option value="priceLowToHigh">Price: Low to High</option>
        <option value="priceHighToLow">Price: High to Low</option>
        <option value="kmLowToHigh">Kilometers: Low to High</option>
        <option value="kmHighToLow">Kilometers: High to Low</option>
        <option value="yearHighToLow">Year: High to Low</option>
        <option value="yearLowToHigh">Year: Low to High</option>
      </select>
    </div>
  </div>
</div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value);  
                                        //  if (filteredResult.length !== prevLength) { 
                                        setIsImageLoading(true); 
                                        //  setPrevLength(filteredResult.length);}
                                         }} />
                                  </div>
                              </div>
                          </div>
                 
                
                  </div>
                      
                  <table id="examples"  class="display inventory_table_list dataTable dtr-inline" style={{ width: "100%" }} >
                
                  <thead>
                      <tr >
                      {showCheckbox && (
        <th width="5%">
          <input type="checkbox" ref={selectAllCheckboxRef}  checked={getCurrentData().every((item) => selectedRows.includes(item.id))} onChange={handleSelectAll} />
        </th>
      )}
                        <th width="20%" style={{paddingLeft:"12px"}}>Vehicle Image</th>
                        <th>Vehicle Details</th>
                        <th style={{ paddingLeft: "15px" }}>Price</th>
                      </tr>
                    </thead>    
                
                    <tbody>
                    {filteredResult.length === 0 ? 
                

                    <div class="row" style={{margin: "10px -900px 10px 10px"}}>
                    <p id="recordMessage" valign="top" class="odd" style={{ textAlign: "center" }} >No records found</p> 
                    </div>
                      : null} 

                    {getCurrentData().map(function fn(item) {

                     return (
                      <>
                       <tr key={item.id}>
                       {showCheckbox && (
                        <td style={{ verticalAlign: "middle" }}>
                         <input
                           type="checkbox"
                           onChange={(e) => handleRowSelect(e, item.id)}   checked={selectedRows.includes(item.id)}/>
                       </td>
                       )}
                       <Link to={`/inventory-details/${item.id}`} style={{ display: "contents", cursor: "pointer" }}>
                          

                             <td>
                               <div class="inventory_list_vehicle_image pt-4">
                                 <div class="container" style={{ position: "relative" }}>
                              

                                 {(isImageLoading && item.coverImage) ? <img style={{ width: "180px", height: "120px" }} onLoad={handleImageLoad} src={placeholderImage} />
                                 
                                 : <img style={{ width: "180px", height: "120px" }}  src={item.coverImage ? `${LARAVEL_API_URL}${item.coverImage.filepath}` : placeholderImage} />

}
{!item.coverImage && (
    <span 
      style={{
        position: "absolute", 
        top: "50%", 
        left: "50%", 
        transform: "translate(-50%, -50%)", 
        color: "#000",
        backgroundColor: "rgba(255, 255, 255, 0.7)", // Optional: Adds a background to the text for better readability
        padding: "2px 5px", // Optional: Adds padding around the text
        borderRadius: "3px" // Optional: Rounds the corners of the text background
      }}
    >
      No image available
    </span>
)} 




   {/* {isImageLoading && item.coverImage && <img style={{ width: "180px", height: "120px" }} src={placeholderImage} />}
 
   {/* {isImageLoading && item.coverImage && <img style={{ width: "180px", height: "120px" }} src={placeholderImage} />}
                                   {item.coverImage ? (

  <img
    style={isImageLoading ? { width: "90%", height: "90%" } : {
      width: "180px",
      height: "120px",
      backgroundColor: "lightgray",
      backgroundImage: `url(${placeholderImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
  }}

    src={`${LARAVEL_API_URL}${item.coverImage.filepath}`}
    onLoad={handleImageLoad}
  />
) : (
<div style={{ 
  position: 'relative', 
  width: '180px', 
  height: '120px', 
  backgroundColor: 'lightgray', 
  backgroundImage: `url(${placeholderImage})`, 
  backgroundSize: 'cover', 
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

}}>
  <span style={{
    position: 'absolute',
    color: 'grey',
    padding: '10px 20px',
    borderRadius: '5px',
    fontSize: '12px',
    marginBottom:'-70px'
  }}>{'Image not available'}</span>
</div>
)} */}
                                   <div style={{
                                     position: 'absolute',
                                     bottom: '5px',
                                     left: '15px',
                                     backgroundColor: 'white',
                                     padding: '5px',
                                     display: 'flex',
                                     alignItems: 'center',
                                     fontSize: "12px"
                                   }}>

                                     <span><i class="bi bi-camera-fill" aria-hidden="true"></i> {item.count}</span>
                                   </div>
                                 </div>
                               </div>
                             </td>
                             <td>
                               <div class="inventory_list_content py-3">
                                 <div class="d-flex justify-content-between align-items-end">

                                   <h4 style={{ display: "flex", alignItems: "center" }}>
                                     {item.vehicle_name} {item.trim} {item.drive_type}
                                     {item.global_inventory == "true" ? <span style={{ backgroundColor: "#059618", fontSize: "12px", borderRadius: "50%", marginLeft: "10px" }} class="badge badge-success">G</span> : null}
                                   </h4>

                                   <div class="d-flex align-items-center justify-content-end">
                                     {/* <p class="pe-3">2 Weeks Ago</p> */}
                                     <button class="btn btn_secondary py-0 " style={{marginLeft:"513px"}}>Bid</button>
                                   </div>
                                 </div>
                                 <div style={{ display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                   {item.key_description}
                                 </div>
                                 {/* <p>Come see How Nissan Downtown is changing the Way Toronto Buys Cars Contact us or better yet, let us arrange a concierge test drive from your home or office* Nissan Downtown - Part of the Downtown Automotive.</p> */}
                                 <div class="d-flex align-items-center pt-1">



                                   {/* <div class="ms-3">
      
      <i class="bi bi-star-fill text-warning"></i>
      <i class="bi bi-star-fill text-warning"></i>
      <i class="bi bi-star-fill text-warning"></i>
      <i class="bi bi-star-fill text-warning"></i>
      <i class="bi bi-star"></i>
    </div> */}

                                 </div>

                                 <div class="d-flex align-items-center pt-1 ">

                                   <h4 style={{ paddingBottom: "5px" }}>
                                     <svg class="b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" data-icon="true"><path fill="currentColor" d="M5.632 6.632c3.509-3.51 9.219-3.51 12.728 0 3.509 3.509 3.509 9.219 0 12.728a0.748 0.748 0 01-1.06 0 0.75 0.75 0 010-1.06c2.923-2.925 2.923-7.683 0-10.608-2.925-2.924-7.683-2.924-10.608 0-2.924 2.925-2.924 7.683 0 10.607a0.75 0.75 0 11-1.06 1.06c-3.51-3.508-3.51-9.218 0-12.727z"></path><path fill="currentColor" d="M11.466 8.776a0.73 0.73 0 01-0.22-0.53 0.738 0.738 0 010.127-0.418 0.79 0.79 0 010.335-0.275 0.753 0.753 0 011.037 0.693 0.738 0.738 0 01-0.127 0.417 0.754 0.754 0 01-1.04 0.205 0.79 0.79 0 01-0.112-0.092zM8.923 15.66a0.834 0.834 0 010.245 0.163 0.758 0.758 0 010.163 0.818 0.821 0.821 0 01-0.163 0.245 0.767 0.767 0 01-0.53 0.217 0.769 0.769 0 01-0.532-0.218 0.82 0.82 0 01-0.162-0.245 0.718 0.718 0 01-0.058-0.288 0.759 0.759 0 010.335-0.622 0.846 0.846 0 010.13-0.07 0.88 0.88 0 010.14-0.042 0.808 0.808 0 010.292 0 0.865 0.865 0 010.14 0.043zm8.353-2.134a0.802 0.802 0 000.162-0.243 0.739 0.739 0 00-0.162-0.817 0.751 0.751 0 00-1.28 0.53 0.753 0.753 0 000.897 0.734 0.687 0.687 0 000.268-0.112 0.703 0.703 0 000.115-0.092zm-10.56-1.06a0.774 0.774 0 011.06 0 0.754 0.754 0 010.22 0.53 0.754 0.754 0 01-0.75 0.75 0.753 0.753 0 01-0.75-0.75c0-0.198 0.08-0.39 0.22-0.53zm8.492 3.152a0.728 0.728 0 00-0.27 0.112 0.752 0.752 0 00-0.333 0.623 0.768 0.768 0 000.218 0.532 0.758 0.758 0 001.06 0 0.759 0.759 0 000.22-0.532c0-0.198-0.08-0.39-0.217-0.53a0.767 0.767 0 00-0.678-0.205zM9.26 9.22a0.811 0.811 0 010.07 0.13 0.714 0.714 0 010.057 0.285 0.77 0.77 0 01-0.219 0.533 0.767 0.767 0 01-0.53 0.218 0.76 0.76 0 01-0.532-0.218A0.77 0.77 0 017.9 9.491a0.904 0.904 0 010.042-0.14 0.83 0.83 0 010.163-0.245 0.782 0.782 0 011.062 0A1.063 1.063 0 019.261 9.22zm7.016 0.556a0.75 0.75 0 10-1.06-1.06l-0.383 0.382a0.04 0.04 0 01-0.005 0.004l-0.005 0.004-0.004 0.005a0.045 0.045 0 01-0.005 0.005l-2.024 2.025a2.002 2.002 0 00-2.794 1.835c0 1.103 0.897 2 2 2a2.002 2.002 0 001.846-2.767l2.434-2.433z"></path></svg>
                                   </h4><p style={{ paddingLeft: "4px" }}>{item.odometer.toLocaleString()} KM</p>


                                   <h4 style={{ paddingBottom: "5px", paddingLeft: "15px" }}>
                                     <svg class="d3n44x b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" data-icon="true" aria-label="Transmission"><path fill="currentColor" fill-rule="evenodd" d="M21 5a2 2 0 10-2.75 1.853v4.397h-5.5V6.853a2 2 0 10-1.5 0v4.397h-5.5V6.853a2 2 0 10-1.5 0v10.294a2 2 0 101.5 0V12.75h5.5v4.397a2 2 0 101.5 0V12.75h7V6.853A2 2 0 0021 5z" clip-rule="evenodd"></path></svg>
                                   </h4><p style={{ paddingLeft: "3px" }}>{item.transmission}</p>

                                   <h4 style={{ paddingBottom: "5px", paddingLeft: "15px" }}>
                                     <svg class="d3n44x b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" data-icon="true" aria-label="Condition"><path fill="currentColor" d="M7.125 14.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM18 13.126a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z"></path><path fill="currentColor" fill-rule="evenodd" d="M18.877 9.576L17.48 6.79a3.253 3.253 0 00-2.534-1.776c-0.164-0.02-5.727-0.02-5.892 0A3.253 3.253 0 006.52 6.79L5.124 9.576A2.753 2.753 0 003 12.25V18a1 1 0 001 1h1a1 1 0 001-1v-1.5h12V18a1 1 0 001 1h1a1 1 0 001-1v-5.75c0-1.3-0.909-2.39-2.123-2.675zM4.5 12.25A1.25 1.25 0 015.75 11h12.5a1.25 1.25 0 011.25 1.25v2.5A0.25 0.25 0 0119.25 15H4.75a0.25 0.25 0 01-0.25-0.25v-2.5zm3.36-4.787a1.757 1.757 0 011.343-0.956c0.45-0.01 5.145-0.01 5.594 0a1.757 1.757 0 011.342 0.956L17.161 9.5H6.839l1.022-2.037z" clip-rule="evenodd"></path></svg>
                                   </h4><p style={{ paddingLeft: "3px" }}>{item.condition}</p>

                                 </div>

                               </div>
                             </td>
                             <td>
                               <div class="inventory_list_price" style={{ padding: "0px 5px 0px 5px" }}>
                                 <h3 class="vm_font_bold">${item.price && item.price.sale_price ? item.price.sale_price.toLocaleString() : ''}</h3>
                                 <img width="95" src="./img/carloan_master.webp" alt="Carloan Master" />
                                 <div style={{ paddingTop: "10px" }}>
                                   <Link style={{color:"white"}} to={`/edit-inventory/${item.id}`} class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre"><i class="bi bi-pencil-square"></i></Link>

                                   <button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" style={{ background: "red", margin: "0px 0px 0px 10px" }}
                                     onClick={(e) => deleteInventory(e, item.id)}><i class="bi bi-trash3"></i></button>
                                 </div>


                               </div>
                             </td>

                          
                         </Link> </tr></>

);
})} 

                    </tbody>


                    <tfoot>
                    <tr>
                    {showCheckbox && (
                    <th ></th>
                    )}
                        <th width="20%" style={{paddingLeft:"12px"}}>Vehicle Image</th>
                        <th>Vehicle Details</th>
                        <th style={{ paddingLeft: "15px" }}>Price</th>
                      
                      </tr> 
      
                    </tfoot>
                  </table>
                  
                
                  <div class="col-md-3" style={{float:"left",padding:"20px 0px 0px 0px"}}>
                  {filteredResult.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResult.length)} of ${filteredResult.length} entries`}
                    </div>
                    <div class="col-md-9" style={{float:"right"}}>
              <ReactPaginate 
  previousLabel={"< Prev"}
  nextLabel={"Next >"}
  breakLabel={'...'}
  pageCount={Math.ceil(filteredResult.length / perPage)}
  onPageChange={handlePageChange}
  containerClassName={"pagination pagination-sm justify-content-center custom-pagination" } // Bootstrap pagination class
  disabledClassName={"disabled"}
  breakClassName={['page-item']}
  breakLinkClassName={'page-link'}
  pageClassName={'page-item'}
  pageLinkClassName={'page-link'}
  previousClassName={'page-item'}
  previousLinkClassName={'page-link'}
  nextClassName={'page-item'}
  nextLinkClassName={'page-link'}
  activeClassName={['active']}
 
/>
              </div>
             
    
                  </>

{/* 
                        :
                        <>
                          <div class="row">
                
                <div class="col-md-4"><p id="recordDisplay" style={{ color: "green",display: "none", padding: "25px 10px 10px 10px" }}>{searchRecordCount} results found</p></div> 
                <div class="col-md-3" >
                <div class="form-group pt-3">
                <div class="d-flex input_wrapper">
                <input type="text"  class="form-control" style={{height: "37px", boxShadow: "none", borderRadius: "4px"}} value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value);handleSearch();}} placeholder="Search..."/></div>
</div>
</div>
                <div class="col-md-1 pt-2"> <p style={{padding: "13px",textAlign:"end" }}>Sort by</p> </div>
                <div class="col-md-2 pt-3" style={{paddingTop:"6px",marginLeft:"-30px"}}> 
                              <div class="form-group">
                            
                                  <select class="form-select" name="condition" id="condition" value={sortedOptionSearch} onChange={handleSortedOptionChangesearch}> 
                                  <option value="">Select an option</option>
                                  <option value="postedNewToOld">Posted Date: New to Old</option>
                                  <option value="postedOldToNew">Posted Date: Old to New</option>              
      <option value="priceLowToHigh">Price: Low to High</option>
      <option value="priceHighToLow">Price: High to Low</option>
      <option value="kmLowToHigh">Kilometers: Low to High</option>
      <option value="kmHighToLow">Kilometers: High to Low</option>
      <option value="yearHighToLow">Year: High to Low</option>
      <option value="yearLowToHigh">Year: Low to High</option>
                                  
                                  </select>
                              </div>
                              
                             

                          </div>
                          

                          <div class="col-md-1 pt-2"> <p style={{padding: "13px",textAlign:"end" }}>Display</p> </div>
                <div class="col-md-1 pt-3" style={{paddingTop:"6px",marginLeft:"-30px"}}> 
                <div class="form-group">
                        
                        <select class="form-select" value={perPage} onChange={(e) => {  setCurrentPage(0);setPerPage(Number(e.target.value));}}>
                         <option value="10">10</option>
                         <option value="25">25</option>
                         <option value="50">50</option>
                         <option value="100">100</option>
                       </select>
                       </div>
                </div>
                </div>
                        <table id="examples" class="display inventory_table_list dataTable dtr-inline" style={{width:"100%"}}>
                        <thead>
                            <tr>
                                <th width="20%" style={{paddingLeft:"12px"}}>Vehicle Image</th>
                                <th>Vehicle Details</th>
                                <th style={{paddingLeft:"15px"}}>Price</th>
                               
                            </tr>
                        </thead>
                                    
                       
                        <tbody>
                        {filteredResults.length === 0 ? (
                       
                

                <div class="row" style={{margin: "10px -900px 10px 10px"}}>
                <p  valign="top" class="odd" style={{ textAlign: "center" }} >No matching records found</p> 
                </div>
                 ) : (

                  filteredResults.slice((currentPage * perPage), ((currentPage * perPage)) + perPage).map(function fn(item){  
 
               
                    return(
     <Link to={`/inventory-details/${item.id}`} style={{display: "contents", cursor:"pointer"}}>
                                 <tr>        
                                     <td>                          
                                         <div class="inventory_list_vehicle_image pt-4">
                                         <div class="container" style={{position: "relative"}}>
                                    
      {item.coverImage ? 
           <img style={!isImageLoading ? {    width: "180px",
             height: "120px",
             backgroundColor: "lightgray",
             backgroundImage: `url(${placeholderImage})`,
             backgroundSize: "cover",
             backgroundPosition: "center",
             borderRadius: "5px",} : { width: "90%", height: "90%", borderRadius: "5px" }}   src={`${LARAVEL_API_URL}${item.coverImage.filepath}`} onLoad={handleImageLoad} />
      :"No image found"}
                                          
                                         </div>
                                         </div>
                                     </td>
                                     <td>
                                     <div class="inventory_list_content py-3">
                            <div class="d-flex justify-content-between aliign-items-end">

                            <h4 style={{display: "flex", alignItems: "center"}}>
                            {item.vehicle_name} {item.trim} {item.drive_type}
                                        {item.global_inventory == "true" ? <span style={{backgroundColor:"#059618", fontSize: "12px", borderRadius: "50%",marginLeft: "10px"}} class="badge badge-success">G</span> : null}
                                        </h4>
                             
                              <div class="d-flex align-items-center">
                               
                                <button class="btn btn_secondary py-0">Bid</button>
                              </div>
                            </div>
                          <div style={{display: '-webkit-box',WebkitLineClamp: '2',WebkitBoxOrient: 'vertical',overflow: 'hidden',textOverflow: 'ellipsis'}}>
        {item.key_description}
      </div>
                                      
                            <div class="d-flex align-items-center pt-1">
                           
                            
            
                            </div>

                            <div class="d-flex align-items-center pt-1 ">
                          
                              <h4 style={{paddingBottom:"5px"}}>
                    <svg class="b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" data-icon="true"><path fill="currentColor" d="M5.632 6.632c3.509-3.51 9.219-3.51 12.728 0 3.509 3.509 3.509 9.219 0 12.728a0.748 0.748 0 01-1.06 0 0.75 0.75 0 010-1.06c2.923-2.925 2.923-7.683 0-10.608-2.925-2.924-7.683-2.924-10.608 0-2.924 2.925-2.924 7.683 0 10.607a0.75 0.75 0 11-1.06 1.06c-3.51-3.508-3.51-9.218 0-12.727z"></path><path fill="currentColor" d="M11.466 8.776a0.73 0.73 0 01-0.22-0.53 0.738 0.738 0 010.127-0.418 0.79 0.79 0 010.335-0.275 0.753 0.753 0 011.037 0.693 0.738 0.738 0 01-0.127 0.417 0.754 0.754 0 01-1.04 0.205 0.79 0.79 0 01-0.112-0.092zM8.923 15.66a0.834 0.834 0 010.245 0.163 0.758 0.758 0 010.163 0.818 0.821 0.821 0 01-0.163 0.245 0.767 0.767 0 01-0.53 0.217 0.769 0.769 0 01-0.532-0.218 0.82 0.82 0 01-0.162-0.245 0.718 0.718 0 01-0.058-0.288 0.759 0.759 0 010.335-0.622 0.846 0.846 0 010.13-0.07 0.88 0.88 0 010.14-0.042 0.808 0.808 0 010.292 0 0.865 0.865 0 010.14 0.043zm8.353-2.134a0.802 0.802 0 000.162-0.243 0.739 0.739 0 00-0.162-0.817 0.751 0.751 0 00-1.28 0.53 0.753 0.753 0 000.897 0.734 0.687 0.687 0 000.268-0.112 0.703 0.703 0 000.115-0.092zm-10.56-1.06a0.774 0.774 0 011.06 0 0.754 0.754 0 010.22 0.53 0.754 0.754 0 01-0.75 0.75 0.753 0.753 0 01-0.75-0.75c0-0.198 0.08-0.39 0.22-0.53zm8.492 3.152a0.728 0.728 0 00-0.27 0.112 0.752 0.752 0 00-0.333 0.623 0.768 0.768 0 000.218 0.532 0.758 0.758 0 001.06 0 0.759 0.759 0 000.22-0.532c0-0.198-0.08-0.39-0.217-0.53a0.767 0.767 0 00-0.678-0.205zM9.26 9.22a0.811 0.811 0 010.07 0.13 0.714 0.714 0 010.057 0.285 0.77 0.77 0 01-0.219 0.533 0.767 0.767 0 01-0.53 0.218 0.76 0.76 0 01-0.532-0.218A0.77 0.77 0 017.9 9.491a0.904 0.904 0 010.042-0.14 0.83 0.83 0 010.163-0.245 0.782 0.782 0 011.062 0A1.063 1.063 0 019.261 9.22zm7.016 0.556a0.75 0.75 0 10-1.06-1.06l-0.383 0.382a0.04 0.04 0 01-0.005 0.004l-0.005 0.004-0.004 0.005a0.045 0.045 0 01-0.005 0.005l-2.024 2.025a2.002 2.002 0 00-2.794 1.835c0 1.103 0.897 2 2 2a2.002 2.002 0 001.846-2.767l2.434-2.433z"></path></svg>
                    </h4><p style={{paddingLeft:"4px"}}>{item.odometer.toLocaleString()} KM</p>


                    <h4 style={{paddingBottom:"5px",paddingLeft:"15px"}}>
                    <svg class="d3n44x b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" data-icon="true" aria-label="Transmission"><path fill="currentColor" fill-rule="evenodd" d="M21 5a2 2 0 10-2.75 1.853v4.397h-5.5V6.853a2 2 0 10-1.5 0v4.397h-5.5V6.853a2 2 0 10-1.5 0v10.294a2 2 0 101.5 0V12.75h5.5v4.397a2 2 0 101.5 0V12.75h7V6.853A2 2 0 0021 5z" clip-rule="evenodd"></path></svg>
                    </h4><p style={{paddingLeft:"3px"}}>{item.transmission}</p>

                    <h4 style={{paddingBottom:"5px",paddingLeft:"15px"}}>
                    <svg class="d3n44x b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" data-icon="true" aria-label="Condition"><path fill="currentColor" d="M7.125 14.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM18 13.126a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z"></path><path fill="currentColor" fill-rule="evenodd" d="M18.877 9.576L17.48 6.79a3.253 3.253 0 00-2.534-1.776c-0.164-0.02-5.727-0.02-5.892 0A3.253 3.253 0 006.52 6.79L5.124 9.576A2.753 2.753 0 003 12.25V18a1 1 0 001 1h1a1 1 0 001-1v-1.5h12V18a1 1 0 001 1h1a1 1 0 001-1v-5.75c0-1.3-0.909-2.39-2.123-2.675zM4.5 12.25A1.25 1.25 0 015.75 11h12.5a1.25 1.25 0 011.25 1.25v2.5A0.25 0.25 0 0119.25 15H4.75a0.25 0.25 0 01-0.25-0.25v-2.5zm3.36-4.787a1.757 1.757 0 011.343-0.956c0.45-0.01 5.145-0.01 5.594 0a1.757 1.757 0 011.342 0.956L17.161 9.5H6.839l1.022-2.037z" clip-rule="evenodd"></path></svg>
                    </h4><p style={{paddingLeft:"3px"}}>{item.condition}</p>
                   
                            </div>

                          </div>
                                     </td>
                                     <td>
                                     <div class="inventory_list_price" style={{ padding: "0px 5px 0px 5px" }}>
                            <h3 class="vm_font_bold">${item.price.sale_price.toLocaleString()}</h3>
                            <img width="95" src="./img/carloan_master.webp" alt="Carloan Master" />
                           <div style={{paddingTop:"10px"}}>
                           <Link to={`/edit-inventory/${item.id}`} class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre"><i class="bi bi-pencil-square"></i></Link>

<button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" style={{ background: "red", margin: "0px 0px 0px 10px" }}
  onClick={(e) => deleteInventory(e, item.id)}><i class="bi bi-trash3"></i></button>
                           </div>
                            

                          </div>
                                     </td>
     
                                    }
                                 </tr>
                                 </Link>
                                
                                 );
                             })
                 )
}

                       
                        </tbody>


                        <tfoot>
                        <tr>
                        <th width="20%" style={{paddingLeft:"12px"}}>Vehicle Image</th>
                        <th>Vehicle Details</th>
                        <th style={{ paddingLeft: "15px" }}>Price</th>
                        
                      </tr> 
                        </tfoot>
                    </table>

                    <div class="col-md-3" style={{float:"left",padding:"20px 0px 0px 13px"}}>
                  {filteredResults.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResults.length)} of ${filteredResults.length} entries`}
                    </div>
                    <div class="col-md-9" style={{float:"right"}}>
              <ReactPaginate 
  previousLabel={"< Prev"}
  nextLabel={"Next >"}
  breakLabel={'...'}
  pageCount={Math.ceil(filteredResults.length / perPage)}
  onPageChange={handlePageChange}
  containerClassName={"pagination pagination-sm justify-content-center custom-pagination" } // Bootstrap pagination class
  disabledClassName={"disabled"}
  breakClassName={['page-item']}
  breakLinkClassName={'page-link'}
  pageClassName={'page-item'}
  pageLinkClassName={'page-link'}
  previousClassName={'page-item'}
  previousLinkClassName={'page-link'}
  nextClassName={'page-item'}
  nextLinkClassName={'page-link'}
  activeClassName={['active']}
 
/>
              </div>
                    
                     </>     
                        
} */}

                       
                    </div>
                </div>
            </div>
</div>


            
        </div>
      

      

    </div>
    
    );
}

export default ViewInventory;